var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',{staticClass:"main page-inside payment-result-page"},[_c('div',{staticClass:"main-wrapper"},[_c('div',{staticClass:"section hero-section"},[_c('div',{staticClass:"wrapper"},[_c('div',{staticClass:"title big"},[_vm._v(_vm._s(_vm.$t('Withdrawal unsuccessful')))])])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }